import React, { useContext, useState, useEffect } from 'react';
import { Card, Tabs } from 'antd';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import './index.scss';
import VideoAsset from './VideoAsset';

export type IFilterType = {
  [key: string]: string | null;
};

const { TabPane } = Tabs;
const Parts: React.FC = observer(() => {
  const {
    StaticAssetStore: {
      state: {
        data: { videos, total, offset, limit },
        ui: { assetLoading }
      },
      getAllAsset,
      updateAsset,
      addAsset,
      deleteAsset
    }
  } = useContext(rootContext);
  useEffect(() => {
    getAllAsset(search, limit, offset, 'VIDEO');
  }, []);
  const [search, setSearch] = useState<string>('');
  // const debounced = useDebouncedCallback(search => {
  //   getAllDeletedItems(search, limit, offset);
  // }, 800);
  return (
    <div className="PartsStyles">
      <div className="cardWrapeer">
        <Card>
          {/* <PageHeader title="Recycle Bin">
            <Row justify="space-between">
              <Col>
                <Input.Search
                  className="search_input_control"
                  loading={recyclerLoading}
                  allowClear
                  value={search}
                  onChange={e => {
                    setSearch(e.target.value);
                    debounced(e.target.value);
                  }}
                  placeholder="Search"
                />
              </Col>
            </Row>
          </PageHeader> */}
          <Tabs
            defaultActiveKey="1"
            // @ts-ignore
            onChange={data => getAllDeletedItems(search, limit, offset, data)}
          >
            <TabPane style={{ color: 'white' }} tab="Videos" key="VIDEOS">
              <VideoAsset />
            </TabPane>

            {/* <TabPane
              style={{ color: 'white' }}
              tab="Shortcut Keys"
              key="SHORTCUT_KEYS"
            >
              <ShortCutKeys />
            </TabPane> */}
          </Tabs>
        </Card>
      </div>
    </div>
  );
});

export default Parts;
